const cachedImages = new Map();

export function preloadImages(urls, updateProgressCallback, allImagesLoadedCallback) {
  let count = 0;
  const total = urls.length;

  urls.forEach((url) => {
    if (cachedImages.has(url)) {
      count++;
      updateProgressCallback(count / total);
      if (count === total) {
        allImagesLoadedCallback();
      }
      return;
    }

    const img = new Image();
    img.src = url;
    img.onload = () => {
      cachedImages.set(url, img);
      count++;
      updateProgressCallback(count / total); // Обновление прогресса
      if (count === total) {
        allImagesLoadedCallback();
      }
    };
  });
}

export function getCachedImage(url) {
  return cachedImages.get(url);
}